/**
* 上下游管理 接口配置
*/
<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>上下游管理</el-breadcrumb-item>
            <el-breadcrumb-item>接口配置</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" class="user-search">
            <el-form-item label="应用" v-if="isShowAPPID">
                <el-select size="small" v-model="app_id" clearable placeholder="请选择" class="userRole">
                    <el-option v-for="roleItem in appList" :key="roleItem.app_id" :label="roleItem.app_name"
                        :value="roleItem.app_id"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <!--列表-->
        <div class="el-table-con">
            <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                element-loading-text="拼命加载中" style="width: 100%;">
                <el-table-column prop="type" label="接口类型">
                </el-table-column>
                <el-table-column prop="desc" label="接口描述">
                </el-table-column>
                <el-table-column align="center" label="操作" width="300">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="handleEdit(scope.row)" v-auth="'appapiinfo.apimanage'">配置
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <span><b>备注：若要复制其他应用配置，链接中的参数app_id_copy设置为待复制接口配置的应用ID即可。</b></span>
        </div>
        <!-- 排重编辑界面 -->
        <el-dialog :title="title" :visible.sync="PCFormVisible" width="50%" @click='closeDialog("PCForm")' @close='handleCancle'>
            <el-form label-width="120px" :model="PCForm" ref="PCForm" :rules="PCrules">
                <el-form-item label="排重URL" prop="request_url" style="margin-bottom: 0;">
                    <el-input size="small" v-model="PCForm.request_url" placeholder="请输入排重URL" auto-complete="off">
                    </el-input>
                    <span style="color: #909399;">url不携带任何参数，例：http://www.xx.com或http://www.xx.com/a/b/c</span>
                </el-form-item>
                <el-form-item label="参数配置" prop="paramlist">
                    <span style="color: #909399;">参数名与参数值一一对应；请选择玖逸可提供值或自定义值</span>
                    <div class="configure_con">
                        <div class="configure_title">
                            <div class="configure_title_item analysis_title_star">客户参数</div>
                            <div class="configure_title_item analysis_title_star">平台参名/参值</div>
                            <div class="configure_title_item analysis_title_star">编码格式</div>
                            <div class="configure_title_item analysis_title_star">请求方式</div>
                            <div class="configure_title_item">
                                <el-button size="mini" type="primary" @click="addDispoaehang('PCForm')">添加参数</el-button>
                            </div>
                        </div>
                        <div v-for="(item,index) in PCForm.paramlist" :key="index" class="configure_list">
                            <div class="configure_list_item">
                                <el-form-item class="configure_list_items" :prop="`paramlist[${index}].app_param_name`"
                                    :rules="paramrules.app_param_name">
                                    <el-input size="small" v-model="item.app_param_name" placeholder="客户参数"
                                        auto-complete="off">
                                    </el-input>
                                </el-form-item>
                                <el-form-item class="configure_list_items"
                                    :prop="`paramlist[${index}].plat_param_value`" :rules="paramrules.plat_param_value">
                                    <el-autocomplete size="small" popper-class="my-autocomplete"
                                        v-model="item.plat_param_value" :fetch-suggestions="paramValueSearch"
                                        placeholder="平台参名/参值" @select="handleSelect($event,index,'PCForm','plat_param_value')">
                                        <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                                        <template slot-scope="{ item }">
                                            <div class="name">{{ item.value }}</div>
                                        </template>
                                    </el-autocomplete>
                                </el-form-item>
                                <el-form-item class="configure_list_items"
                                    :prop="`paramlist[${index}].param_value_encoding`"
                                    :rules="paramrules.param_value_encoding">
                                    <el-autocomplete size="small" popper-class="my-autocomplete"
                                        v-model="item.param_value_encoding" :fetch-suggestions="paramEncodingSearch"
                                        placeholder="编码格式" @select="handleSelect($event,index,'PCForm','param_value_encoding')">
                                        <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                                        <template slot-scope="{ item }">
                                            <div class="name">{{ item.value }}</div>
                                        </template>
                                    </el-autocomplete>
                                </el-form-item>
                                <el-form-item class="configure_list_items" :prop="`paramlist[${index}].request_method`"
                                    :rules="paramrules.request_method">
                                    <el-select size="small" v-model="item.request_method" placeholder="请选择"
                                        class="userRole">
                                        <el-option label="get" :value="0"></el-option>
                                        <el-option label="post" :value="1"></el-option>
                                    </el-select>
                                </el-form-item>
                                <div class="configure_list_items_btn">
                                    <el-button size="mini" type="primary"
                                        :icon="infixshow.length && infixshow[index].isShow?'el-icon-minus':'el-icon-plus'"
                                        @click="addDispoaelie(index)"></el-button>
                                    <el-button size="mini" type="primary" icon="el-icon-delete"
                                        @click="addDispoaehangdel(index,'PCForm')">
                                    </el-button>
                                </div>
                            </div>
                            <div class="infixs_con" v-show="infixshow.length && infixshow[index].isShow">
                                <div class="infixs_title">
                                    <div class="infixs_title_item analysis_title_star">类型</div>
                                    <div class="infixs_title_item analysis_title_star">缀值</div>
                                    <div class="infixs_title_item analysis_title_star">编码格式</div>
                                    <div class="infixs_title_item">
                                        <el-button size="mini" type="primary" @click="addDispoaeval(index,'PCForm')">添加
                                        </el-button>
                                    </div>
                                </div>
                                <div v-for="(cell,idx) in item.infixs" :key="idx" class="infixs_list">
                                    <div class="infixs_list_item">
                                        <el-form-item class="infixs_list_items"
                                            :prop="`paramlist[${index}].infixs[${idx}].infix_type`"
                                            :rules="infixrules.infix_type">
                                            <el-select size="small" v-model="cell.infix_type" placeholder="请选择"
                                                class="userRole">
                                                <el-option label="前缀" :value="0"></el-option>
                                                <el-option label="后缀" :value="1"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item class="infixs_list_items"
                                            :prop="`paramlist[${index}].infixs[${idx}].infix_value`"
                                            :rules="infixrules.infix_value">
                                            <el-autocomplete popper-class="my-autocomplete" v-model="cell.infix_value"
                                                :fetch-suggestions="paramValueSearch" placeholder="缀值" @select="handleSelect($event,index,'PCForm','infix_value','infixs',idx)">
                                                <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                                                <template slot-scope="{ item }">
                                                    <div class="name">{{ item.value }}</div>
                                                </template>
                                            </el-autocomplete>
                                        </el-form-item>
                                        <el-form-item class="infixs_list_items"
                                            :prop="`paramlist[${index}].infixs[${idx}].infix_value_encoding`"
                                            :rules="infixrules.infix_value_encoding">
                                            <el-autocomplete popper-class="my-autocomplete"
                                                v-model="cell.infix_value_encoding"
                                                :fetch-suggestions="paramEncodingSearch" placeholder="编码格式" @select="handleSelect($event,index,'PCForm','infix_value_encoding','infixs',idx)">
                                                <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                                                <template slot-scope="{ item }">
                                                    <div class="name">{{ item.value }}</div>
                                                </template>
                                            </el-autocomplete>
                                        </el-form-item>
                                        <div class="infixs_list_items_btn">
                                            <el-button size="mini" type="primary"
                                                @click="addDispoaedel(index,idx,'PCForm')">删除
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="响应解析">
                    <div class="analysis">
                        <el-form-item class="analysis_item">
                            <div class="analysis_title">参数定位</div>
                            <div class="analysis_input">
                                <el-input size="small" v-model="PCForm.resp_position" placeholder="参数定位"
                                    auto-complete="off">
                                </el-input>
                            </div>
                        </el-form-item>
                        <el-form-item class="analysis_item">
                            <div class="analysis_title">设备ID参名</div>
                            <div class="analysis_input">
                                <el-input size="small" v-model="PCForm.deviceid_param_name" placeholder="设备ID参名"
                                    auto-complete="off">
                                </el-input>
                            </div>
                        </el-form-item>
                        <el-form-item class="analysis_item">
                            <div class="analysis_title">设备状态参名</div>
                            <div class="analysis_input">
                                <el-input size="small" v-model="PCForm.devicestatus_param_name" placeholder="设备状态参名"
                                    auto-complete="off">
                                </el-input>
                            </div>
                        </el-form-item>
                        <el-form-item class="analysis_item" prop="distinct_pass_value"
                            :rules="paramrules.distinct_pass_value">
                            <div class="analysis_title analysis_title_star">通过状态</div>
                            <div class="analysis_input">
                                <el-input size="small" v-model="PCForm.distinct_pass_value" placeholder="通过状态"
                                    auto-complete="off">
                                </el-input>
                            </div>
                        </el-form-item>
                    </div>
                </el-form-item>
                <el-form-item label="最大排重" prop="distinct_qty_max" style="width: 400px;">
                    <el-input size="small" v-model="PCForm.distinct_qty_max" placeholder="请输入最大排重" auto-complete="off">
                    </el-input>
                </el-form-item>
                <el-form-item label="排重持续" prop="distinct_continue" style="width: 400px;">
                    <el-select size="small" v-model="PCForm.distinct_continue" placeholder="请选择" class="userRole">
                        <el-option label="持续" :value="0"></el-option>
                        <el-option label="日排重" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="提交方式" prop="request_method" style="width: 200px;">
                    <el-select size="small" v-model="PCForm.request_method" placeholder="请选择" class="userRole">
                        <el-option label="get" :value="0"></el-option>
                        <el-option label="post" :value="1"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click='closeDialog("PCForm")'>取消</el-button>
                <el-button size="small" type="primary" class="title" @click="submitForm('PCForm')">
                    保存
                </el-button>
            </div>
        </el-dialog>
        <!-- 点击编辑界面 -->
        <el-dialog :title="title" :visible.sync="DJFormVisible" width="50%" @click='closeDialog("DJForm")' @close='handleCancle'>
            <el-form label-width="120px" :model="DJForm" ref="DJForm" :rules="DJrules">
                <el-form-item label="点击URL" prop="request_url" style="margin-bottom: 0;">
                    <el-input size="small" v-model="DJForm.request_url" placeholder="请输入点击URL" auto-complete="off">
                    </el-input>
                    <span style="color: #909399;">url不携带任何参数，例：http://www.xx.com或http://www.xx.com/a/b/c</span>
                </el-form-item>
                <el-form-item label="参数配置" prop="paramlist">
                    <span style="color: #909399;">参数名与参数值一一对应；请选择玖逸可提供值或自定义值</span>
                    <div class="configure_con">
                        <div class="configure_title">
                            <div class="configure_title_item analysis_title_star">客户参数</div>
                            <div class="configure_title_item analysis_title_star">平台参名/参值</div>
                            <div class="configure_title_item analysis_title_star">编码格式</div>
                            <div class="configure_title_item analysis_title_star">请求方式</div>
                            <div class="configure_title_item">
                                <el-button size="mini" type="primary" @click="addDispoaehang('DJForm')">添加参数</el-button>
                            </div>
                        </div>
                        <div v-for="(item,index) in DJForm.paramlist" :key="index" class="configure_list">
                            <div class="configure_list_item">
                                <el-form-item class="configure_list_items" :prop="`paramlist[${index}].app_param_name`"
                                    :rules="paramrules.app_param_name">
                                    <el-input size="small" v-model="item.app_param_name" placeholder="客户参数"
                                        auto-complete="off">
                                    </el-input>
                                </el-form-item>
                                <el-form-item class="configure_list_items"
                                    :prop="`paramlist[${index}].plat_param_value`" :rules="paramrules.plat_param_value">
                                    <el-autocomplete size="small" popper-class="my-autocomplete"
                                        v-model="item.plat_param_value" :fetch-suggestions="paramValueSearch"
                                        placeholder="平台参名/参值" @select="handleSelect($event,index,'DJForm','plat_param_value')">
                                        <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                                        <template slot-scope="{ item }">
                                            <div class="name">{{ item.value }}</div>
                                        </template>
                                    </el-autocomplete>
                                </el-form-item>
                                <el-form-item class="configure_list_items"
                                    :prop="`paramlist[${index}].param_value_encoding`"
                                    :rules="paramrules.param_value_encoding">
                                    <el-autocomplete size="small" popper-class="my-autocomplete"
                                        v-model="item.param_value_encoding" :fetch-suggestions="paramEncodingSearch"
                                        placeholder="编码格式" @select="handleSelect($event,index,'DJForm','param_value_encoding')">
                                        <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                                        <template slot-scope="{ item }">
                                            <div class="name">{{ item.value }}</div>
                                        </template>
                                    </el-autocomplete>
                                </el-form-item>
                                <el-form-item class="configure_list_items" :prop="`paramlist[${index}].request_method`"
                                    :rules="paramrules.request_method">
                                    <el-select size="small" v-model="item.request_method" placeholder="请选择"
                                        class="userRole">
                                        <el-option label="get" :value="0"></el-option>
                                        <el-option label="post" :value="1"></el-option>
                                    </el-select>
                                </el-form-item>
                                <div class="configure_list_items_btn">
                                    <el-button size="mini" type="primary"
                                        :icon="infixshow.length && infixshow[index].isShow?'el-icon-minus':'el-icon-plus'"
                                        @click="addDispoaelie(index)"></el-button>
                                    <el-button size="mini" type="primary" icon="el-icon-delete"
                                        @click="addDispoaehangdel(index,'DJForm')">
                                    </el-button>
                                </div>
                            </div>
                            <div class="infixs_con" v-show="infixshow.length && infixshow[index].isShow">
                                <div class="infixs_title">
                                    <div class="infixs_title_item analysis_title_star">类型</div>
                                    <div class="infixs_title_item analysis_title_star">缀值</div>
                                    <div class="infixs_title_item analysis_title_star">编码格式</div>
                                    <div class="infixs_title_item">
                                        <el-button size="mini" type="primary" @click="addDispoaeval(index,'DJForm')">添加
                                        </el-button>
                                    </div>
                                </div>
                                <div v-for="(cell,idx) in item.infixs" :key="idx" class="infixs_list">
                                    <div class="infixs_list_item">
                                        <el-form-item class="infixs_list_items"
                                            :prop="`paramlist[${index}].infixs[${idx}].infix_type`"
                                            :rules="infixrules.infix_type">
                                            <el-select size="small" v-model="cell.infix_type" placeholder="请选择"
                                                class="userRole">
                                                <el-option label="前缀" :value="0"></el-option>
                                                <el-option label="后缀" :value="1"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item class="infixs_list_items"
                                            :prop="`paramlist[${index}].infixs[${idx}].infix_value`"
                                            :rules="infixrules.infix_value">
                                            <el-autocomplete popper-class="my-autocomplete" v-model="cell.infix_value"
                                                :fetch-suggestions="paramValueSearch" placeholder="缀值" @select="handleSelect($event,index,'DJForm','infix_value','infixs',idx)">
                                                <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                                                <template slot-scope="{ item }">
                                                    <div class="name">{{ item.value }}</div>
                                                </template>
                                            </el-autocomplete>
                                        </el-form-item>
                                        <el-form-item class="infixs_list_items"
                                            :prop="`paramlist[${index}].infixs[${idx}].infix_value_encoding`"
                                            :rules="infixrules.infix_value_encoding">
                                            <el-autocomplete popper-class="my-autocomplete"
                                                v-model="cell.infix_value_encoding"
                                                :fetch-suggestions="paramEncodingSearch" placeholder="编码格式" @select="handleSelect($event,index,'DJForm','infix_value_encoding','infixs',idx)">
                                                <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                                                <template slot-scope="{ item }">
                                                    <div class="name">{{ item.value }}</div>
                                                </template>
                                            </el-autocomplete>
                                        </el-form-item>
                                        <div class="infixs_list_items_btn">
                                            <el-button size="mini" type="primary"
                                                @click="addDispoaedel(index,idx,'DJForm')">删除
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="响应解析">
                    <div class="analysis">
                        <el-form-item class="analysis_item">
                            <div class="analysis_title">参数定位</div>
                            <div class="analysis_input">
                                <el-input size="small" v-model="DJForm.resp_position" placeholder="参数定位"
                                    auto-complete="off">
                                </el-input>
                            </div>
                        </el-form-item>
                        <el-form-item class="analysis_item">
                            <div class="analysis_title">设备状态参名</div>
                            <div class="analysis_input">
                                <el-input size="small" v-model="DJForm.devicestatus_param_name" placeholder="设备状态参名"
                                    auto-complete="off">
                                </el-input>
                            </div>
                        </el-form-item>
                        <el-form-item class="analysis_item" prop="click_pass_value"
                            :rules="paramrules.click_pass_value">
                            <div class="analysis_title analysis_title_star">通过状态</div>
                            <div class="analysis_input">
                                <el-input size="small" v-model="DJForm.click_pass_value" placeholder="通过状态"
                                    auto-complete="off">
                                </el-input>
                            </div>
                        </el-form-item>
                        <el-form-item class="analysis_item" prop="click_verify" :rules="paramrules.click_verify">
                            <div class="analysis_title analysis_title_star">点击验证</div>
                            <div class="analysis_input">
                                <el-select size="small" v-model="DJForm.click_verify" placeholder="请选择"
                                    class="userRole">
                                    <el-option label="否" :value="0"></el-option>
                                    <el-option label="是" :value="1"></el-option>
                                </el-select>
                            </div>
                        </el-form-item>
                    </div>
                </el-form-item>
                <el-form-item label="提交方式" prop="request_method" style="width: 200px;">
                    <el-select size="small" v-model="DJForm.request_method" placeholder="请选择" class="userRole">
                        <el-option label="get" :value="0"></el-option>
                        <el-option label="post" :value="1"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click='closeDialog("DJForm")'>取消</el-button>
                <el-button size="small" type="primary" class="title" @click="submitForm('DJForm')">
                    保存
                </el-button>
            </div>
        </el-dialog>
        <!-- 激活编辑界面 -->
        <el-dialog :title="title" :visible.sync="JHFormVisible" width="50%" @click='closeDialog("JHForm")' @close='handleCancle'>
            <el-form label-width="120px" :model="JHForm" ref="JHForm" :rules="JHrules">
                <el-form-item label="激活URL" prop="request_url" style="margin-bottom: 0;">
                    <el-input size="small" v-model="JHForm.request_url" placeholder="请输入激活URL" auto-complete="off">
                    </el-input>
                    <span style="color: #909399;">url不携带任何参数，例：http://www.xx.com或http://www.xx.com/a/b/c</span>
                </el-form-item>
                <el-form-item label="参数配置" prop="paramlist">
                    <span style="color: #909399;">参数名与参数值一一对应；请选择玖逸可提供值或自定义值</span>
                    <div class="configure_con">
                        <div class="configure_title">
                            <div class="configure_title_item analysis_title_star">客户参数</div>
                            <div class="configure_title_item analysis_title_star">平台参名/参值</div>
                            <div class="configure_title_item analysis_title_star">编码格式</div>
                            <div class="configure_title_item analysis_title_star">请求方式</div>
                            <div class="configure_title_item">
                                <el-button size="mini" type="primary" @click="addDispoaehang('JHForm')">添加参数</el-button>
                            </div>
                        </div>
                        <div v-for="(item,index) in JHForm.paramlist" :key="index" class="configure_list">
                            <div class="configure_list_item">
                                <el-form-item class="configure_list_items" :prop="`paramlist[${index}].app_param_name`"
                                    :rules="paramrules.app_param_name">
                                    <el-input size="small" v-model="item.app_param_name" placeholder="客户参数"
                                        auto-complete="off">
                                    </el-input>
                                </el-form-item>
                                <el-form-item class="configure_list_items"
                                    :prop="`paramlist[${index}].plat_param_value`" :rules="paramrules.plat_param_value">
                                    <el-autocomplete size="small" popper-class="my-autocomplete"
                                        v-model="item.plat_param_value" :fetch-suggestions="paramValueSearch"
                                        placeholder="平台参名/参值" @select="handleSelect($event,index,'JHForm','plat_param_value')">
                                        <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                                        <template slot-scope="{ item }">
                                            <div class="name">{{ item.value }}</div>
                                        </template>
                                    </el-autocomplete>
                                </el-form-item>
                                <el-form-item class="configure_list_items"
                                    :prop="`paramlist[${index}].param_value_encoding`"
                                    :rules="paramrules.param_value_encoding">
                                    <el-autocomplete size="small" popper-class="my-autocomplete"
                                        v-model="item.param_value_encoding" :fetch-suggestions="paramEncodingSearch"
                                        placeholder="编码格式" @select="handleSelect($event,index,'JHForm','param_value_encoding')">
                                        <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                                        <template slot-scope="{ item }">
                                            <div class="name">{{ item.value }}</div>
                                        </template>
                                    </el-autocomplete>
                                </el-form-item>
                                <el-form-item class="configure_list_items" :prop="`paramlist[${index}].request_method`"
                                    :rules="paramrules.request_method">
                                    <el-select size="small" v-model="item.request_method" placeholder="请选择"
                                        class="userRole">
                                        <el-option label="get" :value="0"></el-option>
                                        <el-option label="post" :value="1"></el-option>
                                    </el-select>
                                </el-form-item>
                                <div class="configure_list_items_btn">
                                    <el-button size="mini" type="primary"
                                        :icon="infixshow.length && infixshow[index].isShow?'el-icon-minus':'el-icon-plus'"
                                        @click="addDispoaelie(index)"></el-button>
                                    <el-button size="mini" type="primary" icon="el-icon-delete"
                                        @click="addDispoaehangdel(index,'JHForm')">
                                    </el-button>
                                </div>
                            </div>
                            <div class="infixs_con" v-show="infixshow.length && infixshow[index].isShow">
                                <div class="infixs_title">
                                    <div class="infixs_title_item analysis_title_star">类型</div>
                                    <div class="infixs_title_item analysis_title_star">缀值</div>
                                    <div class="infixs_title_item analysis_title_star">编码格式</div>
                                    <div class="infixs_title_item">
                                        <el-button size="mini" type="primary" @click="addDispoaeval(index,'JHForm')">添加
                                        </el-button>
                                    </div>
                                </div>
                                <div v-for="(cell,idx) in item.infixs" :key="idx" class="infixs_list">
                                    <div class="infixs_list_item">
                                        <el-form-item class="infixs_list_items"
                                            :prop="`paramlist[${index}].infixs[${idx}].infix_type`"
                                            :rules="infixrules.infix_type">
                                            <el-select size="small" v-model="cell.infix_type" placeholder="请选择"
                                                class="userRole">
                                                <el-option label="前缀" :value="0"></el-option>
                                                <el-option label="后缀" :value="1"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item class="infixs_list_items"
                                            :prop="`paramlist[${index}].infixs[${idx}].infix_value`"
                                            :rules="infixrules.infix_value">
                                            <el-autocomplete popper-class="my-autocomplete" v-model="cell.infix_value"
                                                :fetch-suggestions="paramValueSearch" placeholder="缀值" @select="handleSelect($event,index,'JHForm','infix_value','infixs',idx)">
                                                <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                                                <template slot-scope="{ item }">
                                                    <div class="name">{{ item.value }}</div>
                                                </template>
                                            </el-autocomplete>
                                        </el-form-item>
                                        <el-form-item class="infixs_list_items"
                                            :prop="`paramlist[${index}].infixs[${idx}].infix_value_encoding`"
                                            :rules="infixrules.infix_value_encoding">
                                            <el-autocomplete popper-class="my-autocomplete"
                                                v-model="cell.infix_value_encoding"
                                                :fetch-suggestions="paramEncodingSearch" placeholder="编码格式" @select="handleSelect($event,index,'JHForm','infix_value_encoding','infixs',idx)">
                                                <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                                                <template slot-scope="{ item }">
                                                    <div class="name">{{ item.value }}</div>
                                                </template>
                                            </el-autocomplete>
                                        </el-form-item>
                                        <div class="infixs_list_items_btn">
                                            <el-button size="mini" type="primary"
                                                @click="addDispoaedel(index,idx,'JHForm')">删除
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="提交方式" prop="request_method" style="width: 200px;">
                    <el-select size="small" v-model="JHForm.request_method" placeholder="请选择" class="userRole">
                        <el-option label="get" :value="0"></el-option>
                        <el-option label="post" :value="1"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click='closeDialog("JHForm")'>取消</el-button>
                <el-button size="small" type="primary" class="title" @click="submitForm('JHForm')">
                    保存
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    let change = [];
    import {
        appList,
        appApiDist,
        appApiDistSave,
        appApiClick,
        appApiClickSave,
        appApiActiv,
        appApiActivSave
    } from '../../api/basisMG'
    export default {
        inject: ['reload'],
        data() {
            return {
                loading: false, //是显示加载
                isShowAPPID: true,
                PCFormVisible: false, //排重显示与隐藏
                DJFormVisible: false, //点击显示与隐藏
                JHFormVisible: false, //激活显示与隐藏
                title:'',
                PCForm: {},
                DJForm: {},
                JHForm: {},
                // rules 表单验证
                PCrules: {
                    distinct_pass_value: [
                        { required: true, message: '请输入通过状态', trigger: 'blur' }
                    ],
                    distinct_qty_max: [
                        { required: true, message: '请输入最大排重', trigger: 'blur' }
                    ],
                    distinct_continue: [
                        { required: true, message: '请选择排重持续', trigger: 'blur' }
                    ],
                    request_method: [
                        { required: true, message: '请选择请求方式', trigger: 'blur' }
                    ],
                },
                DJrules: {
                    click_verify: [
                        { required: true, message: '请选择点击验证', trigger: 'blur' }
                    ],
                    click_pass_value: [
                        { required: true, message: '请输入通过状态', trigger: 'blur' }
                    ],
                    request_method: [
                        { required: true, message: '请选择请求方式', trigger: 'blur' }
                    ],
                },
                JHrules: {
                    request_method: [
                        { required: true, message: '请选择请求方式', trigger: 'blur' }
                    ],
                },
                paramrules: {
                    app_param_name: [
                        { required: true, message: '请输入应用参名', trigger: 'blur' }
                    ],
                    plat_param_value: [
                        { required: true, message: '请选择平台参值', trigger: ['blur', 'change'] }
                    ],
                    param_value_encoding: [
                        { required: true, message: '请选择参值编码', trigger: ['blur', 'change'] }
                    ],
                    request_method: [
                        { required: true, message: '请选择请求方式', trigger: 'blur' }
                    ],
                },
                infixrules: {
                    infix_type: [
                        { required: true, message: '请选择类型', trigger: 'blur' }
                    ],
                    infix_value: [
                        { required: true, message: '请选择缀值', trigger: ['blur', 'change'] }
                    ],
                    infix_value_encoding: [
                        { required: true, message: '请选择编码格式', trigger: ['blur', 'change'] }
                    ],
                },
                app_id: '',
                app_id_copy: '',
                listData: [{
                    disp_id: 1,
                    type: '排重接口',
                    desc: '请求广告主排重接口，判定用户是否符合推广要求'
                }, {
                    disp_id: 2,
                    type: '点击接口',
                    desc: '请求广告主点击接口，并判定返回结果'
                }, {
                    disp_id: 3,
                    type: '激活接口',
                    desc: '请求广告主激活接口，并判定返回结果'
                }], //固定默认数据
                appList: [], //应用列表
                platParamValueList: [ //平台参值
                    { value: "idfa" , label: "#{idfa}" },
                    { value: "ip" , label: "#{ip}" },
                    { value: "timestamp" , label: "#{timestamp}" },
                    { value: "timestamp13" , label: "#{timestamp13}" },
                    { value: "useragent" , label: "#{useragent}" },
                    { value: "callback" , label: "#{callback}" },
                    { value: "devicemodel" , label: "#{devicemodel}" },
                    { value: "systemversion" , label: "#{systemversion}" },
                    { value: "keyword" , label: "#{keyword}" }
                ],
                paramValueEncodingList: [ //参值编码
                    { value: "默认" , label: " " },
                    { value: "hash" , label: "hash" },
                    { value: "md5big" , label: "md5big" },
                    { value: "md5small" , label: "md5small" },
                    { value: "urlencode" , label: "urlencode" },
                    { value: "urlencodebig" , label: "urlencodebig" },
                    { value: "sha1" , label: "sha1" },
                    { value: "sha256" , label: "sha256" }
                ],
                infixshow: []
            }
        },
        // 注册组件
        components: {},
        /**
         * 数据发生改变
         */

        watch: {},

        /**
         * 创建完毕
         */

        created() { },
        mounted() {
            if (this.$route.query.app_id) {
                this.app_id = this.$route.query.app_id;
                this.isShowAPPID = false;
            }
            if (this.$route.query.app_id_copy) {
                this.app_id_copy = this.$route.query.app_id_copy;
            }
            this.getappList();
        },
        /**
         * 里面的方法只有被调用才会执行
         */

        methods: {
            // 获取应用列表
            getappList() {
                var that = this;
                var data = { 'pagesize': '0' }
                appList(data)
                    .then(res => {
                        if (res.statusCode == 200) {
                            that.appList = res.data.datas
                        } else {
                            that.$message.error(res.message)
                        }
                    })
            },
            // 获取排重接口配置
            getappApiDist() {
                var that = this;
                var data = { 'app_id': that.app_id, 'app_id_copy': that.app_id_copy }
                appApiDist(data)
                    .then(res => {
                        if (res.statusCode == 200) {
                            var data = res.data
                            if (data == null) {
                                data = {
                                    request_url: "",
                                    request_method: 0,
                                    paramlist: [],
                                    resp_position: "",
                                    deviceid_param_name: "",
                                    devicestatus_param_name: "",
                                    distinct_pass_value: "",
                                    distinct_qty_max: 0,
                                    distinct_continue: 0
                                }
                            }
                            if (data.paramlist == null) {
                                data.paramlist = []
                            }
                            if (data.paramlist && data.paramlist.length) {
                                data.paramlist.forEach(item => {
                                    if (item.infixs == null) {
                                        item.infixs = []
                                    }
                                    that.infixshow.push({ isShow: false });
                                });
                            }
                            that.PCForm = data
                        } else {
                            that.$message.error(res.message)
                        }
                    })
            },
            // 获取点击接口配置
            getappApiClick() {
                var that = this;
                var data = { 'app_id': that.app_id, 'app_id_copy': that.app_id_copy }
                appApiClick(data)
                    .then(res => {
                        if (res.statusCode == 200) {
                            var data = res.data
                            if (data == null) {
                                data = {
                                    request_url: "",
                                    request_method: 0,
                                    paramlist: [],
                                    resp_position: "",
                                    devicestatus_param_name: "",
                                    click_pass_value: "",
                                    click_verify: 0,
                                }
                            }
                            if (data.paramlist == null) {
                                data.paramlist = []
                            }
                            if (data.paramlist && data.paramlist.length) {
                                data.paramlist.forEach(item => {
                                    if (item.infixs == null) {
                                        item.infixs = []
                                    }
                                    that.infixshow.push({ isShow: false });
                                });
                            }
                            that.DJForm = data
                        } else {
                            that.$message.error(res.message)
                        }
                    })
            },
            // 获取激活接口配置
            getappApiActiv() {
                var that = this;
                var data = { 'app_id': that.app_id, 'app_id_copy': that.app_id_copy }
                appApiActiv(data)
                    .then(res => {
                        if (res.statusCode == 200) {
                            var data = res.data
                            if (data == null) {
                                data = {
                                    request_url: "",
                                    request_method: 0,
                                    paramlist: [],
                                }
                            }
                            if (data.paramlist == null) {
                                data.paramlist = []
                            }
                            if (data.paramlist && data.paramlist.length) {
                                data.paramlist.forEach(item => {
                                    if (item.infixs == null) {
                                        item.infixs = []
                                    }
                                    that.infixshow.push({ isShow: false });
                                });
                            }
                            that.JHForm = data
                        } else {
                            that.$message.error(res.message)
                        }
                    })
            },
            // 添加参数行
            addDispoaehang(type) {
                var form = ''
                if (type == 'PCForm') {
                    form = this.PCForm
                } else if (type == 'DJForm') {
                    form = this.DJForm
                } else if (type == 'JHForm') {
                    form = this.JHForm
                }
                if (form) {
                    form.paramlist.push({
                        app_param_name: "",
                        plat_param_value: "",
                        param_value_encoding: "",
                        request_method: 0,
                    })
                    this.infixshow.push({ isShow: false });
                }
            },
            // 展开参数列
            addDispoaelie(index) {
                var isShow = this.infixshow[index].isShow
                this.infixshow[index].isShow = !isShow
            },
            // 删除行
            addDispoaehangdel(index, type) {
                var form = ''
                if (type == 'PCForm') {
                    form = this.PCForm
                } else if (type == 'DJForm') {
                    form = this.DJForm
                } else if (type == 'JHForm') {
                    form = this.JHForm
                }
                if (form) {
                    form.paramlist.splice(index, 1);
                    this.infixshow.splice(index, 1);
                }
            },
            // 添加缀值
            addDispoaeval(index, type) {
                var form = ''
                if (type == 'PCForm') {
                    form = this.PCForm
                } else if (type == 'DJForm') {
                    form = this.DJForm
                } else if (type == 'JHForm') {
                    form = this.JHForm
                }
                if (form) {
                    form.paramlist[index].infixs.push({
                        infix_type: 0,
                        infix_value: "",
                        infix_value_encoding: ""
                    })
                }
            },
            // 删除缀值
            addDispoaedel(index, idx, type) {
                var form = ''
                if (type == 'PCForm') {
                    form = this.PCForm
                } else if (type == 'DJForm') {
                    form = this.DJForm
                } else if (type == 'JHForm') {
                    form = this.JHForm
                }
                if (form) {
                    form.paramlist[index].infixs.splice(idx, 1);
                }
            },
            //显示编辑界面
            handleEdit: function (row) {
                if (!this.app_id) {
                    this.$message.error('请先选择应用！');
                    return;
                }
                this.infixshow = [];
                if (row.disp_id == 1) {
                    this.getappApiDist();
                    this.title = '排重配置'
                    this.PCFormVisible = true
                } else if (row.disp_id == 2) {
                    this.getappApiClick();
                    this.title = '点击配置'
                    this.DJFormVisible = true                    
                } else if (row.disp_id == 3) {
                    this.getappApiActiv();
                    this.title = '激活配置'
                    this.JHFormVisible = true
                }
            },
            // 编辑、增加页面保存方法
            submitForm(Form) {
                var editForm = ''
                if (Form == 'PCForm') {
                    editForm = this.PCForm;
                } else if (Form == 'DJForm') {
                    editForm = this.DJForm;
                } else if (Form == 'JHForm') {
                    editForm = this.JHForm;
                }
                editForm.app_id = this.app_id;
                var that = this;
                this.$refs[Form].validate(valid => {
                    if (valid) {
                        if (Form == 'PCForm') {
                            appApiDistSave(editForm)
                                .then(res => {
                                    that.PCFormVisible = false
                                    if (res.statusCode == 200) {
                                        that.$message({
                                            type: 'success',
                                            message: that.title + '成功！'
                                        })
                                    } else {
                                        that.$message.error(res.message)
                                    }
                                })
                        } else if (Form == 'DJForm') {
                            appApiClickSave(editForm)
                                .then(res => {
                                    that.DJFormVisible = false
                                    if (res.statusCode == 200) {
                                        that.$message({
                                            type: 'success',
                                            message: that.title + '成功！'
                                        })
                                    } else {
                                        that.$message.error(res.message)
                                    }
                                })
                        } else if (Form == 'JHForm') {
                            appApiActivSave(editForm)
                                .then(res => {
                                    that.JHFormVisible = false
                                    if (res.statusCode == 200) {
                                        that.$message({
                                            type: 'success',
                                            message: that.title + '成功！'
                                        })
                                    } else {
                                        that.$message.error(res.message)
                                    }
                                })
                        }
                    } else {
                        return false
                    }
                })
            },
            // 添加table必填标识
            star({ columnIndex }) {
                if (columnIndex < 4) {
                    return 'star'
                }
            },
            // 添加table必填标识
            starin({ columnIndex }) {
                if (columnIndex < 3) {
                    return 'star'
                }
            },
            // 关闭编辑、增加弹出框
            closeDialog(type) {
                if (type == 'PCForm') {
                    this.PCFormVisible = false
                } else if (type == 'DJForm') {
                    this.DJFormVisible = false
                } else if (type == 'JHForm') {
                    this.JHFormVisible = false
                }
            },
            // Dialog关闭事件
            handleCancle () {
                window.location.reload();
            },
            // 自定义输入下拉框
            paramValueSearch(queryString, cb) {
                var platParamValueList = this.platParamValueList;
                var results = queryString ? platParamValueList.filter(this.createFilter(queryString)) : platParamValueList;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            paramEncodingSearch(queryString, cb) {
                var paramValueEncodingList = this.paramValueEncodingList;
                var results = queryString ? paramValueEncodingList.filter(this.createFilter(queryString)) : paramValueEncodingList;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return restaurant.value.toUpperCase().match(queryString.toUpperCase()) //模糊查询
                    // return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0); // 精准查询
                };
            },
            handleSelect(item,index,form,vaule,value1,idx){
                if(form == 'PCForm'){
                    if(!value1){
                        this.PCForm.paramlist[index][vaule] = item.label
                    }else{
                        this.PCForm.paramlist[index].infixs[idx][vaule] = item.label
                    }
                }else if(form == 'DJForm'){
                    if(!value1){
                        this.DJForm.paramlist[index][vaule] = item.label
                    }else{
                        this.DJForm.paramlist[index].infixs[idx][vaule] = item.label
                    }
                }else if(form == 'JHForm'){
                    if(!value1){
                        this.JHForm.paramlist[index][vaule] = item.label
                    }else{
                        this.JHForm.paramlist[index].infixs[idx][vaule] = item.label
                    }
                }
            }
        }
    }
</script>
<style>
    .el-table-con {
        height: calc(100vh - 380px) !important;
    }

    .page-box {
        text-align: right !important;
    }

    /* 固定el-table头部 */
    .el-table {
        max-height: calc(100vh - 380px) !important;
    }

    .el-table__body-wrapper.is-scrolling-none {
        overflow-y: auto !important;
        max-height: calc(100vh - 460px) !important;
    }

    .el-table__body-wrapper.is-scrolling-none::-webkit-scrollbar {
        display: none;
    }

    .el-dialog__body {
        max-height: 55vh;
        overflow-y: scroll;
    }

    .el-dialog__body::-webkit-scrollbar {
        display: none;
    }
</style>
<style scoped>
    .user-search {
        margin-top: 20px;
    }

    .userRole {
        width: 100%;
    }

    .infixs_con,
    .configure_con {
        display: flex;
        flex-direction: column;
        border-top: 1px solid #EBEEF5;
        border-left: 1px solid #EBEEF5;
        box-sizing: border-box;
    }

    .infixs_con {
        background-color: #F2F6FC;
        border-top: none;
    }

    .infixs_con .infixs_title,
    .configure_con .configure_title {
        display: flex;
    }

    .infixs_con .infixs_title .infixs_title_item,
    .configure_con .configure_title .configure_title_item {
        width: 20%;
        padding: 8px 10px;
        text-align: center;
        border-right: 1px solid #EBEEF5;
        border-bottom: 1px solid #EBEEF5;
        box-sizing: border-box;
    }

    .infixs_con .infixs_title .infixs_title_item {
        width: 25%;
    }

    .infixs_con .infixs_list,
    .configure_con .configure_list {
        display: flex;
        flex-direction: column;
    }

    .infixs_con .infixs_list .infixs_list_item,
    .configure_con .configure_list .configure_list_item {
        display: flex;
    }

    .infixs_con .infixs_list .infixs_list_item .infixs_list_items,
    .configure_con .configure_list .configure_list_item .configure_list_items {
        width: 20%;
        padding: 8px 10px;
        text-align: center;
        border-bottom: 1px solid #EBEEF5;
        border-right: 1px solid #EBEEF5;
        box-sizing: border-box;
    }

    .infixs_con .infixs_list .infixs_list_item .infixs_list_items {
        width: 25%;
    }

    .infixs_con .infixs_list .infixs_list_item .infixs_list_items_btn,
    .configure_con .configure_list .configure_list_item .configure_list_items_btn {
        width: 20%;
        padding: 12px;
        border-bottom: 1px solid #EBEEF5;
        border-right: 1px solid #EBEEF5;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
    }

    .infixs_con .infixs_list .infixs_list_item .infixs_list_items_btn {
        width: 25%;
    }

    /* 解析 */
    .analysis {
        display: flex;
        width: 100%;
        margin: 0;
        padding: 0;
        border-top: 1px solid #EBEEF5;
        border-left: 1px solid #EBEEF5;
    }

    .analysis .analysis_item {
        list-style: none;
        text-align: center;
    }

    .analysis .analysis_item .analysis_title {
        color: #909399;
        padding: 8px 10px;
        border-bottom: 1px solid #EBEEF5;
        border-right: 1px solid #EBEEF5;
    }

    .analysis .analysis_item .analysis_input {
        padding: 8px 10px;
        border-bottom: 1px solid #EBEEF5;
        border-right: 1px solid #EBEEF5;
    }

    .analysis_title_star:before {
        content: '*';
        color: red;
        padding-right: 3px;
    }

    /* table 添加必填标识 */
    /deep/.el-table table th.star div:before {
        content: '*';
        color: red;
        padding-right: 3px;
    }
    .el-form-item .el-form-item__content .el-table {
        max-height: none !important;
    }

    .el-form-item .el-form-item__content .el-table__body-wrapper.is-scrolling-none {
        overflow-y: initial !important;
        max-height: none !important;
    }
</style>


// WEBPACK FOOTER //
// src/views/control/dispose.vue